/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_NicknameInputs */



/**
* | output |
* | --- |
* | "Nickname" |
*
* @param {Common_NicknameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_nickname = /** @type {((inputs?: Common_NicknameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_NicknameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pseudo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apodo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apelido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Soprannome")
	return /** @type {LocalizedString} */ ("Nickname")
});